module.exports = __webpack_public_path__ + "img/11.315dbffd.jpg";